// eslint-disable-next-line
import { RouteView, PageView } from '@/layouts'

export const userRouter = [
  {
    path: '/users',
    redirect: '/users/userList',
    component: RouteView,
    meta: { title: '用户', keepAlive: true, icon: 'user' },
    name: 'UserGroup',
    children: [
      {
        path: '/users/manager',
        component: RouteView,
        redirect: '/users/userList',
        meta: { title: '用户管理', keepAlive: true },
        name: 'UserManagerGroup',
        children: [
          {
            path: '/users/userList',
            name: 'UserList',
            component: () => import('@/views/user/UserList'),
            meta: {
              title: '用户列表', keepAlive: true,
            }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/merchant/userDetail',
            name: 'UserDetail',
            component: () => import('@/views/user/UserDetail'),
            meta: { title: '用户详情', keepAlive: false, hideInMenu: true, hidePermissionTree: true }
          },
          {
            path: '/users/userLabel',
            name: 'UserLabel',
            component: () => import('@/views/user/UserLabel'),
            meta: { title: '用户标签', keepAlive: false }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/createUserTags',
            name: 'CreateUserTags',
            component: () => import('@/views/user/CreateUserTags'),
            meta: { title: '创建用户标签', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/EmployeeDiscount',
            name: 'EmployeeDiscount',
            component: () => import('@/views/platform/employeeVerification/EmployeeDiscount'),
            meta: { title: '员工优惠', keepAlive: false, hideInMenu: true }
          },
          {
            //ignorePermissions:true,//忽略权限控制
            path: '/platform/studentVerify/list',
            name: 'StudentVerify',
            component: () => import('@/views/platform/studentVerify/List.vue'),
            meta: {
              title: '大学生认证',
              keepAlive: true
            }
          },
          {
            //ignorePermissions:true,//忽略权限控制
            path: '/platform/verification/list',
            name: 'VerificationList',
            component: () => import('@/views/platform/employeeVerification/VerificationList.vue'),
            meta: {
              title: '员工认证',
              keepAlive: true
            }
          },
          {
            path: '/platform/employee/list',
            name: 'EmployeeList',
            hidden: true,
            hidePermissionTree: true,//不出现在权限菜单中
            ignorePermissions: true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/EmployeeList.vue'),
            meta: {
              title: '员工列表',
              groupName: 'VerificationList',
              keepAlive: true,
              hideInMenu: true,
              hidePermissionTree: true,
              ignorePermissions: true
            }
          },
          {
            path: '/platform/employee/discount/usage/list',
            name: 'EnterpriseDiscountUsageRecord',
            hidden: true,
            hidePermissionTree: true,//不出现在权限菜单中
            ignorePermissions: true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/EnterpriseDiscountUsageRecord.vue'),
            meta: {
              title: '员工首次充值',
              groupName: 'VerificationList',
              keepAlive: true,
              hideInMenu: true,
              hidePermissionTree: true,
              ignorePermissions: true
            }
          },
          {
            path: '/platform/employee/recharge/list',
            name: 'FirstRechargeList',
            hidden: true,
            // hidePermissionTree:true,//不出现在权限菜单中
            // ignorePermissions:true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/FirstRechargeList.vue'),
            meta: {
              title: '员工首次充值',
              groupName: 'VerificationList',
              keepAlive: true,
              hideInMenu: true
            }
          },
          {
            path: '/platform/employee/approval/workflow',
            name: 'ApprovalWorkflow',
            hidden: true,
            hidePermissionTree: true,//不出现在权限菜单中
            ignorePermissions: true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/ApprovalWorkflow.vue'),
            meta: {
              title: '审批流',
              groupName: 'VerificationList',
              keepAlive: true,
              hideInMenu: true,
              hidePermissionTree: true,
              ignorePermissions: true
            }
          },
          {
            path: '/platform/employee/authentication/setting',
            name: 'AuthenticationSettings',
            hidden: true,
            hidePermissionTree: true,//不出现在权限菜单中
            ignorePermissions: true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/AuthenticationSettings.vue'),
            meta: {
              groupName: 'VerificationList',
              title: '认证设置',
              keepAlive: true,
              hideInMenu: true,
              hidePermissionTree: true,
              ignorePermissions: true
            }
          },
          {
            path: '/platform/employee/organizational/structure',
            name: 'OrganizationalStructure',
            hidden: true,
            hidePermissionTree: true,//不出现在权限菜单中
            ignorePermissions: true,//忽略权限控制
            component: () => import('@/views/platform/employeeVerification/OrganizationalStructure.vue'),
            meta: {
              groupName: 'VerificationList',
              title: '组织架构',
              keepAlive: true,
              hideInMenu: true,
              hidePermissionTree: true,
              ignorePermissions: true
            }
          }
        ]
      },
      {
        path: '/users/rights',
        component: RouteView,
        redirect: '/users/rights/list',
        meta: { title: '权益管理', keepAlive: true },
        name:'usersRightsGroup',
        children: [
          {
            path: '/users/rights/list',
            name: 'MemberLists',
            component: () => import('@/views/user/rightsManage/MemberList'),
            meta: { title: '会员卡', keepAlive: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/rights/newCard',
            name: 'NewMemberCard',
            component: () => import('@/views/user/rightsManage/NewMemberCard'),
            meta: { title: '新建会员卡', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/rights/transactionDetail',
            name: 'MemberCardTransactionDetail',
            component: () => import('@/views/user/rightsManage/MemberCardTransactionDetail'),
            meta: { title: '交易明细', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/rights/electron',
            name: 'ElectronCardList',
            component: () => import('@/views/user/rightsManage/ElectronCardList'),
            meta: { title: '销售数据-高级会员卡', keepAlive: true, hideInMenu: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/rights/entity',
            name: 'EntityCardList',
            component: () => import('@/views/user/rightsManage/EntityCardList'),
            meta: { title: '销售数据-高级会员卡', keepAlive: true, hideInMenu: true }
          },
          {
            path: '/users/member/ascend/list',
            name: 'MemberAscendList',
            component: () => import('@/views/user/member/MemberAscendList'),
            meta: { title: '会员等级', keepAlive: false }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/member/ascend/edit',
            name: 'EditMemberAscend',
            component: () => import('@/views/user/member/EditMemberAscend'),
            meta: { title: '编辑会员等级', keepAlive: false, hideInMenu: true }
          }
        ]
      },
      {
        path: '/users/integral',
        component: RouteView,
        redirect: '/users/integral/list',
        meta: { title: '积分管理', keepAlive: false },
        name:'userIntegralGroup',
        children: [
          {
            path: '/users/integral/list',
            name: 'IntegralRule',
            component: () => import('@/views/user/integral/IntegralRuleList'),
            meta: { title: '积分规则', keepAlive: false }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/integral/new',
            name: 'NewIntegralRule',
            component: () => import('@/views/user/integral/NewIntegralRule'),
            meta: { title: '新建积分规则', keepAlive: false, hideInMenu: true }
          },
          {
            path: '/users/integral/pro/list',
            name: 'IntegralProList',
            component: () => import('@/views/user/integral/IntegralProList'),
            meta: { title: '积分商品', keepAlive: false }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/integral/pro/new',
            name: 'NewIntegralPro',
            component: () => import('@/views/user/integral/NewIntegralPro'),
            meta: { title: '新建积分商品', keepAlive: false, hideInMenu: true }
          },
          {
            path: '/users/integral/order/list',
            name: 'IntegralOrderList',
            component: () => import('@/views/user/integral/IntegralOrderList'),
            meta: { title: '积分订单', keepAlive: false }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/users/integral/order/detail',
            name: 'IntegralOrderDetail',
            component: () => import('@/views/user/integral/IntegralOrderDetail'),
            meta: { title: '积分订单详情', keepAlive: false, hideInMenu: true }
          }
        ]
      }
    ]
  }
]
